import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.search');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;
declare const WizRoute: any;

interface SearchFilters {
    category: string;
    region: string;
    yearFrom: string;
    yearTo: string;
    sort: string;
}

interface SearchResult {
    id?: string;
    title: string;
    pdf_name: string;
    category: string;
    region: string;
    period: string;
    publish_year: number | null;
    summary?: string;
    relevance?: number;
    page?: number;
    series_count?: number;
    doc_meta?: any;
}

@Component({
    selector: 'wiz-page-search',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.search/view.scss */
/* src/app/page.search/view.scss: no such file or directory */`],
})
export class PageSearchComponent implements OnInit {
    public searchText: string = '';
    public filters: SearchFilters = {
        category: '',
        region: '',
        yearFrom: '',
        yearTo: '',
        sort: 'relevance',
    };

    // 필터 옵션
    public categories: string[] = [];
    public regions: string[] = [];
    public yearRange: { min: number | null; max: number | null } = { min: null, max: null };
    public yearOptions: number[] = [];

    // 결과
    public results: SearchResult[] = [];
    public totalResults: number = 0;
    public currentPage: number = 1;
    public pageSize: number = 20;
    public totalPageCount: number = 0;

    // AI 요약
    public searchSummary: string = '';
    public summaryLoading: boolean = false;

    // 상태
    public loading: boolean = false;
    public searched: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();

        // URL 쿼리 파라미터로 초기 검색
        const q = WizRoute.query?.q || '';
        if (q) {
            this.searchText = q;
            await this.search();
        }

        // 필터 옵션 로드
        await this.loadFilters();
        await this.service.render();
    }

    // ── 필터 옵션 로드 ────────────────────────────────

    private async loadFilters() {
        try {
            const { code, data } = await wiz.call('filters');
            if (code === 200) {
                this.categories = data.categories || [];
                this.regions = data.regions || [];
                this.yearRange = data.years || { min: null, max: null };

                // 연도 옵션 생성
                if (this.yearRange.min && this.yearRange.max) {
                    this.yearOptions = [];
                    for (let y = this.yearRange.max; y >= this.yearRange.min; y--) {
                        this.yearOptions.push(y);
                    }
                }
            }
        } catch (e) {
            console.error('Filter load error:', e);
        }
    }

    // ── 검색 ──────────────────────────────────────────

    public async search(page: number = 1) {
        if (!this.searchText.trim()) return;

        this.loading = true;
        this.searched = true;
        this.currentPage = page;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('search', {
                text: this.searchText,
                category: this.filters.category,
                region: this.filters.region,
                year_from: this.filters.yearFrom,
                year_to: this.filters.yearTo,
                sort: this.filters.sort,
                page: page,
                dump: this.pageSize,
            });
            if (code === 200) {
                this.results = data.results || [];
                this.totalResults = data.total || 0;
                this.totalPageCount = Math.ceil(this.totalResults / this.pageSize);
            }
        } catch (e) {
            console.error('Search error:', e);
        } finally {
            this.loading = false;
            await this.service.render();
        }

        // AI 요약은 첫 페이지에서만
        if (page === 1) {
            this.loadSummary();
        }
    }

    private async loadSummary() {
        this.summaryLoading = true;
        this.searchSummary = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('summary', {
                text: this.searchText,
            });
            if (code === 200) {
                this.searchSummary = data.summary || '';
            }
        } catch (e) {
            // 요약 실패는 무시
        } finally {
            this.summaryLoading = false;
            await this.service.render();
        }
    }

    // ── 필터 변경 ─────────────────────────────────────

    public async onFilterChange() {
        await this.search(1);
    }

    public resetFilters() {
        this.filters = {
            category: '',
            region: '',
            yearFrom: '',
            yearTo: '',
            sort: 'relevance',
        };
        this.search(1);
    }

    // ── 페이지네이션 ──────────────────────────────────

    public async goToPage(page: number) {
        if (page < 1 || page > this.totalPageCount) return;
        await this.search(page);
        // 스크롤 상단
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    public get pageNumbers(): number[] {
        const pages: number[] = [];
        const start = Math.max(1, this.currentPage - 2);
        const end = Math.min(this.totalPageCount, this.currentPage + 2);
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    }

    // ── 문서 열기 ─────────────────────────────────────

    public openDocument(result: SearchResult) {
        const docId = result.doc_meta?.id || result.id || '';
        if (docId) {
            this.service.href(`/document/${docId}`);
        }
    }

    // ── 키보드 이벤트 ─────────────────────────────────

    public onSearchKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.search(1);
        }
    }
}

export default PageSearchComponent;